import { EXPRESS_API } from 'configs/api/expressApi';
import { useToastError } from 'lib/hooks';
import { useMutation, useQueryClient } from 'react-query';
import { groupKeys } from './groupKeys';
import { QueryParams } from './useQueryGroups';
import { contactsKeys } from '../contacts/queryKeys';
import { successToast } from 'lib/components/toasts/success';
import { useTranslation } from 'react-i18next';

interface IDeleteGroups {
  groupIds: number[];
  deleteContacts?: boolean;
}

export const deleteGroups = async (data: IDeleteGroups) => {
  const response = await EXPRESS_API.delete('/groups', {
    data,
  });
  return response.data;
};

export const useDeleteGroupsMutation = (
  onSuccess?: () => void,
  queryParams?: QueryParams
) => {
  const { showError } = useToastError();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  return useMutation((data: IDeleteGroups) => deleteGroups(data), {
    onError: err => showError(err),
    onSuccess: async data => {
      await queryClient.invalidateQueries(
        queryParams ? groupKeys.groups(queryParams) : groupKeys.all_groups()
      );
      // also invalidate contacts
      await queryClient.invalidateQueries(contactsKeys.all());
      const isPlural = data.length > 1;
      const successMessage = isPlural
        ? t('Groups were deleted successfully!')
        : t('Group was deleted successfully!');
      successToast({ title: successMessage });
      onSuccess && onSuccess();
    },
  });
};
